// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"3ea9f10d","213":"c770444d","372":"fce305d5","807":"c74867db"}[chunkId] + ".chunk.js";
};